import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'

import PdfViewer from './PdfViewer'
import Header from './Header'

const MobileReportsView = (props) => {
    const {
        pdfsToEmail,
        selectedCard,
        removePdfs,
        handleFetchWithNewUserName,
        reportsQueryRequests
    } = props;


    return (
        <>
            <Header
                handleFetchWithNewUserName={handleFetchWithNewUserName}
                reportsQueryRequests={reportsQueryRequests}
            />
            <div style={{overflowX:"hidden", paddingLeft:"10px", paddingRight:"10px"}}>
            <PdfViewer pdfsToEmail={pdfsToEmail} removePdfs={removePdfs} selectedCard={selectedCard} pdfScale={1}/>
            </div>
        </>
    )
}
export default MobileReportsView;